var $formUpdateUser = $('#edit_user_infos');

$formUpdateUser.on('submit', function(e) {
  e.preventDefault();
  var $firstName = $('input[name=first-name]').val();
  var $lastName = $('input[name=last-name]').val();
  var $email = $('input[name=email]').val();
  var $pass1 = $("#pass1", $("#edit_user_infos")).val();
  var $pass2 = $("#pass2", $("#edit_user_infos")).val();
  var $you_are = $("#choose_you_are", $("#edit_user_infos")).val();
  var $structure = $('input[name=structure]').val();

  var $postInfos = {
    'first-name': $firstName,
    'last-name': $lastName,
    'email': $email,
    'pass1': $pass1,
    'pass2': $pass2,
    'you_are': $you_are,
    'structure': $structure,
  };


  $.ajax({
    type: 'POST',
    url: ajaxurl,
    data: {
      action: 'edit_profile_informations',
      postInfos: $postInfos,
    },
    success: function(data){
        $('.form_status').css('display', 'block').text(data.message);
        if(!data.status_ok) {
          $('.form_status').addClass('error');
        }
    },
  });

});

// delete account
var $deleteAccountBtn = $('.js-delete-account');
var $modal = $("#delete-account-modal");
var $span = $(".close");
var $confirmationButton = $('#confirmation-delete-account-yes');
var $declineButton = $('#confirmation-delete-account-no');

$deleteAccountBtn.on('click', function(e) {
  $modal.show();
  
  $confirmationButton.on('click', function(e) {
    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'delete_account',
      },
      success: function(response) {
        if (response.success) {
          window.location.replace('/');
        } else {
          $('.js-message-delete').append('<p>Une erreur est survenue lors de la suppression de votre compte.</p>');
        }
      },
      error: function() {
        $('.js-message-delete').append('<p>Une erreur est survenue lors de la suppression de votre compte.</p>');
      }
    });
    
  });

});

$(window).on('click', function(event) {
  var target = $(event.target);
  if (target.is($modal)) {
    $modal.hide();
  }
});

$span.on('click', function() {
  $modal.hide();
});

$declineButton.on('click', function() {
  $modal.hide();
});
